<app-spinner [isLoading]="isLoading"></app-spinner>
<img class="img-fluid rounded" width="100%" [src]="fileStreamSource" />
